exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-input-number[data-v-952c9a38] {\n  width: 100%;\n}\n", ""]);

// exports
